import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

// 用户类型定义
export interface User {
  id: string;
  name: string;
  email: string;
  avatar?: string;
  createdAt: string;
  updatedAt: string;
}

// 用户状态
export const userAtom = atomWithStorage<User | null>('user', null);

// 用户加载状态
export const userLoadingAtom = atom<boolean>(false);

// 用户加载错误状态
export const userErrorAtom = atom<string | null>(null);

// 模拟获取用户信息的函数
export const fetchUserAtom = atom(
  null,
  async (get, set) => {
    try {
      set(userLoadingAtom, true);
      set(userErrorAtom, null);
      
      // 模拟API调用
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // 模拟用户数据
      const mockUser: User = {
        id: 'user-1',
        name: '测试用户',
        email: 'user@example.com',
        avatar: undefined,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      };
      
      set(userAtom, mockUser);
      return true;
    } catch (error) {
      console.error('Failed to fetch user:', error);
      set(userErrorAtom, error instanceof Error ? error.message : '获取用户信息失败');
      return false;
    } finally {
      set(userLoadingAtom, false);
    }
  }
);

// 更新用户信息
export const updateUserAtom = atom(
  null,
  async (get, set, userData: Partial<User>) => {
    const currentUser = get(userAtom);
    if (!currentUser) return false;
    
    try {
      set(userLoadingAtom, true);
      set(userErrorAtom, null);
      
      // 模拟API调用
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // 更新用户数据
      const updatedUser: User = {
        ...currentUser,
        ...userData,
        updatedAt: new Date().toISOString(),
      };
      
      set(userAtom, updatedUser);
      return true;
    } catch (error) {
      console.error('Failed to update user:', error);
      set(userErrorAtom, error instanceof Error ? error.message : '更新用户信息失败');
      return false;
    } finally {
      set(userLoadingAtom, false);
    }
  }
);
